module.exports = __webpack_public_path__ + "static/img/4.1990d70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news15/4.png
// module id = pJpd
// module chunks = 1